import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import formatDate from '@/services/general/formatIsoDate';
import { ADEMONTE, DEMONTE, MONTE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import booleanConverter from '@/services/import/General/booleanConverter';
import moment from 'moment';

export default function fillDispositifWithData(
  dispositifReference, dispositif, informationApiReference,
) {
  dispositif.idUniqueDispo = dispositifReference.idUniqueDispo;
  dispositif.code = dispositifReference.codeDispositif ?? '';
  dispositif.nom = dispositifReference.libelleDispositif ?? '';
  dispositif.dispositifSupportId = dispositifReference.supportDispositif ? store
    .getters['parametres/parametre'](PARAMETRES_KEYS.dispositifSupport).find((type) => {
      return type.libelle.toLowerCase().trim()
        === dispositifReference.supportDispositif.toLowerCase().trim();
    }).id : null;
  dispositif.dispositifTypeId = dispositifReference.typeDispositif ? store
    .getters['parametres/parametre'](PARAMETRES_KEYS.dispositifType).find((type) => {
      return type.libelle.toLowerCase().trim()
        === dispositifReference.typeDispositif.toLowerCase().trim();
    }).id : null;
  if (dispositifReference.proprietaire) {
    dispositif.proprietaire = booleanConverter(dispositifReference.proprietaire);
  }
  dispositif.adresse.adresse1 = dispositifReference.adresse1Dispositif ?? '';
  dispositif.adresse.adresse2 = dispositifReference.adresse2Dispositif ?? '';
  dispositif.adresse.adresse3 = dispositifReference.adresse3Dispositif ?? '';
  dispositif.adresse.agglomeration = dispositifReference.agglomerationDispositif ?? '';
  dispositif.adresse.codePostal = dispositifReference.codePostalDispositif ?? '';
  dispositif.adresse.ville = dispositifReference.villeDispositif ?? '';
  dispositif.adresse.pays = dispositifReference.paysDispositif ?? '';
  dispositif.adresse.codeInsee = dispositifReference.codeInseeDispositif ?? '';
  dispositif.adresse.latitude = dispositifReference.latitudeDispositif ?? '';
  dispositif.adresse.longitude = dispositifReference.longitudeDispositif ?? '';
  dispositif.commentaire = dispositifReference.commentaireDispositif ?? '';
  if (dispositifReference.dateMontageDispositif) {
    const dateDefault = moment('31/12/1899', 'DD/MM/YYYY');
    let date = moment(dispositifReference.dateMontageDispositif, 'DD/MM/YYYY');
    if (dateDefault.isSame(date)) date = date.add(1, 'd');
    dispositif.dateMontage = formatDate(date);
  } else dispositif.dateMontage = null;
  dispositif.dateDemontage = dispositifReference.dateDemontageDispositif ? formatDate(moment(dispositifReference.dateDemontageDispositif, 'DD/MM/YYYY')) : null;
  dispositif.PDLElectricite = dispositifReference.pdlelectriciteDispositif ?? '';
  dispositif.avecCaissonPub = booleanConverter(dispositifReference.avecCaissonPub);
  dispositif.iot = dispositifReference.iotDispositif ?? '';

  dispositif.tiersId = dispositifReference.confrereDispositif
    ? informationApiReference
      .confrereDispositif.find((fournisseur) => {
        return fournisseur.nomCommercial === dispositifReference.confrereDispositif;
      }).id : null;

  if (dispositifReference.etatDispositif === 'Monté' || dispositifReference.etatDispositif === 'Monte') {
    dispositif.etat = MONTE;
  } else if (dispositifReference.etatDispositif === 'Démonté' || dispositifReference.etatDispositif === 'Demonte') {
    dispositif.etat = DEMONTE;
  } else if (dispositifReference.etatDispositif === 'A démonté') {
    dispositif.etat = ADEMONTE;
  }

  dispositif.dispositifTechnique.cableEdfProx = booleanConverter(dispositifReference.cableEdfProx);
  dispositif.dispositifTechnique.longueur = dispositifReference.longueur ?? 0;
  dispositif.dispositifTechnique.largeurToit = dispositifReference.largeurToit ?? 0;
  dispositif.dispositifTechnique.nacelleNecessaire = booleanConverter(
    dispositifReference.nacelleNecessaire,
  );
  dispositif.dispositifTechnique.echelleNecessaire = booleanConverter(
    dispositifReference.echelleNecessaire,
  );
  dispositif.dispositifTechnique.grueNecessaire = booleanConverter(
    dispositifReference.grueNecessaire,
  );
  dispositif.dispositifTechnique.couleurRAL = dispositifReference.couleurRal ?? '';
  dispositif.dispositifTechnique.publicitaire = booleanConverter(dispositifReference.publicitaire);
  dispositif.dispositifTechnique.eclairable = booleanConverter(dispositifReference.eclairable);
  dispositif.dispositifTechnique.declarationPrealable = dispositifReference.declarationPrealableDispositif ? formatDate(moment(dispositifReference.declarationPrealableDispositif, 'DD/MM/YYYY')) : null;
  dispositif.dispositifTechnique.planRecollement = dispositifReference.planRecollementDispositif ?? '';
  dispositif.dispositifTechnique.particularite = dispositifReference.particulariteDispositif ?? '';
  dispositif.dispositifTechnique.distanceEnMCablesEdf = dispositifReference.distanceMetreCableEdf
    ?? 0;
  dispositif.dispositifTechnique.fournisseurElectriciteId = dispositifReference
    .fournisseurElectriciteId ?? null;
  dispositif.dispositifTechnique.tiersProprietaireId = dispositifReference
    .proprietaireDispositif ?? null;
  dispositif.dispositifTechnique.hauteurSousPanneau = dispositifReference.hauteurSousPanneau ?? 0;
  dispositif.dispositifTechnique.obstacle = dispositifReference.obstacle ?? '';
  dispositif.dispositifTechnique.valeurAcquisition = dispositifReference.valeurAcquisition ?? 0;
  dispositif.dispositifTechnique.restrictionsAffichage = dispositifReference.restrictionDispositif ?? '';

  dispositif.dispositifTechnique.fournisseurElectriciteId = dispositifReference.fournisseurElec
    ? informationApiReference
      .fournisseurElectricite.find((fournisseur) => {
        return fournisseur.nomCommercial === dispositifReference.fournisseurElec;
      }).id : null;

  dispositif.dispositifTechnique.tiersProprietaireId = dispositifReference.proprietaireDispositif
    ? informationApiReference
      .proprietaire.find((proprio) => {
        return proprio.nomCommercial === dispositifReference.proprietaireDispositif;
      }).id : null;

  dispositif.arretBus = dispositifReference.arretBus ?? '';
  dispositif.societeId = store.getters['societe/societeActiveId'];

  const agences = store.getters['societe/agenceActive'];
  const agence = agences.find((agence) => {
    return agence.libelleAgence === dispositifReference.agence;
  });
  if (agence) dispositif.agenceId = agence.agenceId;
  dispositif.numLigne = dispositifReference.numLigne;

  return dispositif;
}
